import { render } from "./CitasPorFecha.vue?vue&type=template&id=644a0587&scoped=true"
import script from "./CitasPorFecha.vue?vue&type=script&lang=js"
export * from "./CitasPorFecha.vue?vue&type=script&lang=js"

import "@/assets/css/fechaBar.css?vue&type=style&index=0&id=644a0587&scoped=true&lang=css"
import "./CitasPorFecha.vue?vue&type=style&index=1&id=644a0587&scoped=true&lang=css"

import exportComponent from "C:\\Software\\Aplicaciones\\kiatros\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-644a0587"]])

export default __exports__